import i18n from "i18next";

export type OrganizationType = "llp" | "llc" | "jsc" | "ip" | "pf" | "prf" | "pa" | "oyl" | "oyl_ip";

interface OrganizationTypeDetails {
  ru: {
    full_title: string;
    abbreviation: string;
  };
  kk: {
    full_title: string;
    abbreviation: string;
  };
}

function getTranslation(locale: "ru" | "kk", orgType: OrganizationType, field: "fullTitle" | "abbreviation"): string {
  return (
    i18n.getResourceBundle(locale, "Common")?.organizationTypes?.[orgType]?.[field] ||
    i18n.getResourceBundle("ru", "Common")?.organizationTypes?.[orgType]?.[field] ||
    ""
  );
}

export function getOrganizationTypeDetails(orgType: OrganizationType): OrganizationTypeDetails {
  const known: OrganizationType[] = ["llp", "llc", "jsc", "ip", "pf", "prf", "pa", "oyl", "oyl_ip"];
  if (!known.includes(orgType)) {
    throw new Error(`Unknown organization type: ${orgType}. Valid types: ${known.join(", ")}`);
  }

  return {
    ru: {
      full_title: getTranslation("ru", orgType, "fullTitle"),
      abbreviation: getTranslation("ru", orgType, "abbreviation"),
    },
    kk: {
      full_title: getTranslation("kk", orgType, "fullTitle"),
      abbreviation: getTranslation("kk", orgType, "abbreviation"),
    },
  };
}
